import type { CityConfig } from "../city-template/types";

export const stCharlesMOConfig: CityConfig = {
  city: "St. Charles",
  state: "Missouri",
  stateAbbr: "MO",
  slug: "st-charles",
  route: "/st-charles",
  title: "Emergency Passport St. Charles, MO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in St. Charles, MO — as fast as 24 hours. Serving St. Charles County and the greater St. Louis metro. A+ BBB rated registered State Dept. courier serving the historic Missouri River city and the St. Louis suburbs. No office visit required.",
  h1: "Emergency & Expedited Passport Services in St. Charles, MO",
  heroSubtitle: "International business trip from Lambert Airport with a week to spare? Missouri River cruise departing soon and your passport expired? Family trip to Cancun over spring break and the kids need first passports? We help St. Charles residents get their passports fast — as fast as 24 hours. A+ BBB rated registered State Dept. courier. Best price guarantee. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20St.%20Charles%20Missouri%20historic%20Main%20Street%20with%20cobblestone%20streets%20and%20charming%20storefronts%20along%20the%20Missouri%20River%20golden%20hour%20warm%20light%20reflecting%20off%20the%20water%20old%20brick%20buildings%20tree-lined%20streets%20professional%20drone%20photography%20soft%20natural%20tones%20Midwestern%20river%20town%20charm&width=1800&height=700&seq=st-charles-mo-hero-2026&orientation=landscape",
  heroImageAlt: "St. Charles Missouri historic Main Street cobblestone district along the Missouri River at golden hour",
  geoPosition: "38.7881;-90.4974",
  geoPlacename: "St. Charles, Missouri",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "101 Ida B. Wells Drive, 9th Floor, Chicago, IL 60604",
    distance: "Located in downtown Chicago — approximately 310 miles northeast of St. Charles via I-55",
  },
  nearbyCitiesZips: [
    { name: "St. Charles", zips: "63301, 63303, 63304" },
    { name: "O'Fallon", zips: "63366, 63368" },
    { name: "St. Peters", zips: "63376" },
    { name: "Wentzville", zips: "63385" },
    { name: "Lake Saint Louis", zips: "63367" },
    { name: "Weldon Spring", zips: "63304" },
    { name: "Dardenne Prairie", zips: "63368" },
    { name: "Cottleville", zips: "63304" },
    { name: "St. Louis County", zips: "63101–63199" },
    { name: "Chesterfield", zips: "63005, 63017" },
    { name: "Wildwood", zips: "63005, 63021, 63038" },
    { name: "Ballwin", zips: "63011, 63021" },
    { name: "Manchester", zips: "63011" },
    { name: "Creve Coeur", zips: "63141" },
    { name: "Maryland Heights", zips: "63043" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent St. Louis metro departures" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "St. Charles County Hub", desc: "Serving St. Charles, O'Fallon, St. Peters, and the St. Louis suburbs" },
  ],
  internalLinks: [
    { name: "Expedited passport services in St. Louis, MO", route: "/st-louis" },
    { name: "Fast passport renewal in O'Fallon, MO", route: "/ofallon-mo" },
    { name: "Emergency passport help in Columbia, MO", route: "/columbia-mo" },
    { name: "Urgent passport services in Jefferson City, MO", route: "/jefferson-city" },
    { name: "Same-day passport help in Chicago, IL", route: "/chicago" },
    { name: "Passport courier services in Springfield, IL", route: "/springfield-il" },
  ],
  fpcOfficeNote: "Fast Passport Center serves St. Charles remotely via secure courier. We do not have a walk-in office in St. Charles — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for St. Charles County and the St. Louis metro.",
  fpcOfficeAddress: "1200 Main St, Kansas City, Missouri 64105",
  fpcOfficeDistance: "Serving all of St. Charles County and the western St. Louis suburbs including O'Fallon, St. Peters, and Wentzville",
  serviceAreaIntro: "From the historic cobblestone streets of Main Street St. Charles and the Missouri River riverfront to the growing suburbs of O'Fallon and St. Peters, from the master-planned communities of Lake Saint Louis and Dardenne Prairie to the charming towns of Weldon Spring and Cottleville — Fast Passport Center serves the entire St. Charles County and greater St. Louis metro area. We regularly help travelers from St. Charles, O'Fallon, and surrounding communities get their passports fast without the 5-hour drive to Chicago.",
  nearbyCitiesIntro: "We serve all St. Charles neighborhoods and the surrounding St. Charles County area including O'Fallon, St. Peters, Wentzville, Lake Saint Louis, Weldon Spring, and Dardenne Prairie. If you are anywhere in St. Charles County or the western St. Louis suburbs, we have you covered.",
  howItWorksIntro: "Most St. Charles travelers complete everything online and ship documents overnight. No need to drive to Chicago or wait in line at the regional agency.",
  mistakesIntro: "St. Charles travelers often face a 5-hour drive to the nearest regional passport agency in Chicago. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "St. Charles and St. Charles County travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in St. Charles? Here are the most common ones we hear from St. Charles County travelers.",
  statePageRoute: "/states/missouri",
  statePageName: "Missouri",
  dmvWebsite: "https://dor.mo.gov/motor-vehicle/",
  dmvLabel: "Missouri DOR — Motor Vehicle & Driver Licensing",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For St. Charles travelers with immediate departure needs — as fast as 24 hours for urgent international flights from STL.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-bank-card-line",
      title: "Passport Card",
      description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean.",
      bullets: ["REAL ID compliant alternative", "Fits in your wallet", "Land/sea border crossing approved"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
    {
      icon: "ri-error-warning-line",
      title: "Damaged Passport",
      description: "Replacement for water-damaged, torn, or otherwise mutilated passports that are no longer valid for travel.",
      bullets: ["Damage assessment guidance", "DS-11 replacement process", "Supporting documentation help"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-file-copy-line",
      title: "Second Passport",
      description: "Obtain a second valid U.S. passport for frequent international travelers who need overlapping visas.",
      bullets: ["For frequent business travelers", "Overlapping visa support", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
    { name: "Passport Card", description: "Wallet-sized U.S. Passport Card for land and sea travel to Canada, Mexico, Bermuda, and the Caribbean." },
    { name: "Damaged Passport", description: "Replacement for water-damaged, torn, or mutilated passports requiring DS-11 replacement." },
    { name: "Second Passport", description: "Second valid U.S. passport for frequent international travelers with overlapping visa needs." },
  ],
  testimonials: [
    {
      name: "Sarah M.",
      location: "St. Charles, MO",
      rating: 5,
      text: "We had a Paris anniversary trip booked and my husband's passport expired without us noticing. Fast Passport Center got the renewal in 36 hours. We were walking along the Seine four days later. Absolutely incredible!",
      service: "Passport Renewal",
    },
    {
      name: "Tom R.",
      location: "O'Fallon, MO",
      rating: 5,
      text: "Corporate merger trip to Frankfurt came up with 3 days notice. My passport was nowhere to be found. Fast Passport Center got me an emergency passport in 26 hours. I closed the deal. Legendary service.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer L.",
      location: "St. Peters, MO",
      rating: 5,
      text: "Three kids needed first passports for a Disney cruise. Fast Passport Center walked us through everything. All three arrived in 4 days. St. Charles County families — this is the service you need!",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "st-charles-mo-1",
      name: "St. Charles Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1890 S 5th St",
      city: "St. Charles",
      state: "MO",
      zip: "63303",
      phone: "(636) 946-5722",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South St. Charles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary St. Charles facility. Appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "st-charles-mo-2",
      name: "St. Charles County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "201 N 2nd St",
      city: "St. Charles",
      state: "MO",
      zip: "63301",
      phone: "(636) 949-7550",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Historic Downtown St. Charles",
      website: "https://www.sccmo.org",
      websiteLabel: "St. Charles County Clerk",
      notes: "Accepts passport applications at the County Administration Building. Good alternative to post office. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "st-charles-mo-3",
      name: "O'Fallon Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1000 Main St",
      city: "O'Fallon",
      state: "MO",
      zip: "63366",
      phone: "(636) 281-6477",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "8 miles west of St. Charles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves O'Fallon and western St. Charles County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "st-charles-mo-4",
      name: "St. Peters Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1024 Mexico Rd",
      city: "St. Peters",
      state: "MO",
      zip: "63376",
      phone: "(636) 278-8611",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "5 miles west of St. Charles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves St. Peters and central St. Charles County. Full passport services available.",
      icon: "ri-mail-line",
    },
    {
      id: "st-charles-mo-5",
      name: "Wentzville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "201 E Pearce Blvd",
      city: "Wentzville",
      state: "MO",
      zip: "63385",
      phone: "(636) 327-5202",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "12 miles west of St. Charles",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Wentzville and western St. Charles County. Full passport services available.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 5 hour drive to Chicago", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "St. Charles photo shops often use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at St. Charles County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many St. Charles applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Chicago regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many St. Charles County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "St. Charles travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in St. Charles." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your St. Charles address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in St. Charles before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in St. Charles for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 5-hour drive to Chicago." },
    { q: "How fast can I renew my passport in St. Charles?", a: "Fast Passport Center offers fast passport renewal in St. Charles in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to St. Charles?", a: "The nearest regional passport agency to St. Charles is the Chicago Passport Agency, approximately 310 miles northeast via I-55. For urgent processing without the long drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from St. Charles without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near St. Charles?", a: "Same-day passport appointments are only available at the Chicago Regional Passport Agency — approximately 5 hours from St. Charles — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for St. Charles County and St. Louis metro residents." },
    { q: "Do you serve the entire St. Charles County region?", a: "Absolutely. Fast Passport Center serves the entire St. Charles County and western St. Louis metro region including St. Charles, O'Fallon, St. Peters, Wentzville, Lake Saint Louis, and surrounding areas. Our courier service works seamlessly from any address in St. Charles County." },
    { q: "Can I expedite a child passport in St. Charles?", a: "Yes. Fast Passport Center expedites child passports in St. Charles for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk St. Charles County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in St. Charles with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Chicago Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
  ],
  photoLocations: [
    { name: "Walmart Supercenter — St. Charles", address: "2897 Veterans Memorial Pkwy, St. Charles, MO 63303", hours: "Mon–Sun: 6AM–11PM" },
    { name: "Walgreens — St. Charles", address: "2001 Zumbehl Rd, St. Charles, MO 63303", hours: "Mon–Sun: 7AM–11PM" },
    { name: "CVS Pharmacy — O'Fallon", address: "1200 Feise Rd, O'Fallon, MO 63368", hours: "Mon–Sun: 8AM–10PM" },
    { name: "Walmart Supercenter — St. Peters", address: "45 Sutters Mill Rd, St. Peters, MO 63376", hours: "Mon–Sun: 6AM–11PM" },
  ],
  dmvLocations: [
    {
      name: "Missouri DOR — St. Charles",
      address: "2490 Raymond Dr, St. Charles, MO 63301",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Driver license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Missouri DOR — Wentzville",
      address: "1155 Wentzville Pkwy, Wentzville, MO 63385",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves Wentzville and western St. Charles County. REAL ID available. Appointment recommended.",
      featured: false,
    },
    {
      name: "Missouri DOR — Bridgeton",
      address: "11977 St. Charles Rock Rd, Bridgeton, MO 63044",
      hours: "Mon–Fri: 8AM–5PM",
      note: "Serves north St. Louis County. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "STL",
      name: "St. Louis Lambert International Airport",
      distance: "12 miles east of St. Charles",
      address: "10701 Lambert International Blvd, St. Louis, MO 63145",
      note: "Major international hub with direct flights worldwide. About 15 minutes from St. Charles via I-70.",
      flightUrl: "https://www.flystl.com/",
      flightLabel: "STL Airport",
      featured: true,
    },
    {
      code: "COU",
      name: "Columbia Regional Airport",
      distance: "115 miles west of St. Charles",
      address: "11300 Airport Dr, Columbia, MO 65201",
      note: "Regional airport with direct flights to major hubs. About 1 hour 50 minutes from St. Charles via I-70.",
      flightUrl: "https://www.flycou.com/",
      flightLabel: "COU Airport",
      featured: false,
    },
    {
      code: "MCI",
      name: "Kansas City International Airport",
      distance: "245 miles west of St. Charles",
      address: "1 Kansas City Blvd, Kansas City, MO 64153",
      note: "Major international hub. About 3 hours 45 minutes from St. Charles via I-70.",
      flightUrl: "https://www.flykc.com/",
      flightLabel: "MCI Airport",
      featured: false,
    },
  ],
};